import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, Modal, message, Col, Row } from "antd";
import { UserOutlined, LockOutlined, EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import "antd/dist/reset.css"; // or 'antd/dist/antd.less'
import "./SignIn.css";
import { useDispatch } from "react-redux";
import { useHistory, Link, useParams } from "react-router-dom";
// import ReactLoading from "react-loading";
import liracrypt from "../Liracrypt/liracrypt";
import StAddNew from "../../pages/DSeries/StAddNew";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";

function SignIn() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [pwdResetLoading, setPwdResetLoading] = useState(false);
  const { urlCode } = useParams();
  const [pwdForm] = Form.useForm();
  const [isInvalid, setInvalid] = useState(false);
  const [ErrorText, setErrorText] = useState("Invalid Login Credentials !");
  const [ShowLoadingLogin, setShowLoadingLogin] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [resetPwdModal, setResetPwdModal] = useState(false);

  const onFinish = (values) => {
    setShowLoadingLogin(true);
    liracrypt.login(
      {
        username: values.username,
        urlCode,
        password: values.password,
        scode: process.env.REACT_APP_CODE,
        sparsh: "NonSparshLogin"
      },
      dispatch,
      history,
      setShowLoadingLogin,
      setInvalid,
      setErrorText,
      setResetPwdModal
    );
  };

  const clearRecentCache = () => {
    const cacheData = { ...localStorage };
    Object.keys(cacheData).forEach(key => {
      if (key.includes('cache_')) {
        localStorage.removeItem(key);
      }
    });
  }

  useEffect(() => {
    clearRecentCache();
    if(localStorage.getItem('token')){
      dispatch({
        type: 'LOGOUT'
      });
      localStorage.clear();
      // liracrypt.delete('/logout', {})
      // .then(res => {
      //   localStorage.clear();
      // }).catch(err => {
      //   console.log(err);
      // })
    }
  }, []);

  function Invalid() {
    if (isInvalid) {
      return (
        <div style={{ textAlign: "center" }}>
          <div
            className="mx-auto invalidator"
            style={{
              margin: "1rem",
              backgroundColor: "#ff3d41",
              borderRadius: "10px",
              padding: ".4rem",
              color: "#fff",
              fontWeight: "600",
              minWidth: "92%",
            }}
          >
            <span style={{ float: "left", marginLeft: "10px" }}>&#9888;</span>
            <span style={{ marginTop: "3.5px" }}>{ErrorText}</span>
            <a
              style={{ float: "right", marginRight: "2px", color: "#fff" }}
              onClick={() => setInvalid(false)}
            >
              &times;
            </a>
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  }

  const resetPwd = (values) => {
    setPwdResetLoading(true);
    liracrypt.patch('/resetpassword', values)
      .then(response => {
        setPwdResetLoading(false);
        if (response.data.isSuccess) {
          message.success(response.data.message || 'Password Reset Successfully');
          pwdForm.resetFields();
          localStorage.clear();
          setResetPwdModal(false);
          console.log(response.data);
        } else {
          message.error(response.data.message || 'Something went wrong');
        }

      }).catch(err => {
        setPwdResetLoading(false);
        ApiErrorComp();
        console.log(err);
      })
  }

  return (
    <>
      <div
        className=""
        style={{
          minHeight: "100%",
          backgroundColor: "#262626"
        }}
      >
        <div
          className="row align-items-center "
        >
          <div>
            <div className="row justify-content-center">
              <div
                className=" col-10 col-sm-10 col-md-6 col-lg-4"
                style={{
                  boxShadow: "0px 0px 10px 0px black",
                  borderRadius: "15px",
                  backgroundColor: "#1d1d1d",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100vw",

                  height: "100vh",
                }}
              >
                <img
                  alt="Df"
                  src={require('../../assets/static/Df.png')}
                  // src={require("../../images/Tracost.jpeg")}
                  width="300px"
                  style={{ margin: "1rem", marginBottom: 0, padding: "1rem" }}
                />
                <h2
                  style={{
                    padding: ".8rem",
                    paddingBottom: "0",
                    fontWeight: "500",
                    color: "#fff",
                    textAlign: "center",
                    fontSize: "2rem",
                  }}
                >
                  Sign In
                </h2>
                <Form
                  name="normal_login"
                  className="login-form"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  style={{ textAlign: "center", minWidth: "360px" }}
                >
                  <div style={{ marginBottom: ".5rem" }}>
                    <Form.Item
                      name="username"
                      style={{
                        fontWeight: "600",
                      }}
                      rules={[
                        {
                          required: true,
                          message: (
                            <span style={{ marginLeft: "1rem" }}>
                              Please input your Username!
                            </span>
                          ),
                        },
                      ]}
                    >
                      <Input
                        style={{
                          maxWidth: "90%",
                        }}
                        prefix={
                          <UserOutlined className="site-form-item-icon" />
                        }
                        placeholder="Username"
                      />
                    </Form.Item>
                  </div>
                  <div style={{ marginBottom: "1rem" }}>
                    <Form.Item
                      name="password"
                      style={{ fontWeight: "600" }}
                      rules={[
                        {
                          required: true,
                          message: (
                            <span style={{ marginLeft: "1rem" }}>
                              Please input your Password!
                            </span>
                          ),
                        },
                      ]}
                    >
                      <Input
                        style={{
                          maxWidth: "90%",
                        }}
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        suffix={
                          <Button
                            className="show-pwd-btn"
                            onClick={() => setShowPassword(!showPassword)}
                            icon={
                              showPassword ?
                                <EyeInvisibleOutlined /> :
                                <EyeOutlined />
                            }>{''}</Button>
                        }
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                      />
                    </Form.Item>
                  </div>
                  {/* <Form.Item
                    style={{
                      textAlign: "right",
                      marginRight: "20px",
                    }}
                  >
                    <Form.Item name="remember" valuePropName="checked" noStyle>
                      <Checkbox
                        className="float-left"
                        style={{
                          marginLeft: "1.4rem",
                          color: "#fff",
                          fontWeight: "600",
                        }}
                      >
                        Remember me
                      </Checkbox>
                    </Form.Item>
                  </Form.Item> */}

                  <Invalid />

                  <Form.Item>
                    {/* <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button"
                      style={{ borderRadius: "15px", fontWeight: "600" }}
                    >
                      Log in
                    </Button> */}
                    {ShowLoadingLogin ? (
                      <div
                        style={{
                          display: "inline-block",
                        }}
                      >
                        {/* <ReactLoading
                          type="bubbles"
                          color="#007bff"
                          height={20}
                          width={70}
                        /> */}
                      </div>
                    ) : (
                      <div style={{ marginLeft: "25px", marginRight: "10px" }}>
                        <Button
                          size="large"
                          type="primary"
                          htmlType="submit"
                          className="login-form-button"
                          style={{
                            minWidth: "60%",
                            fontWeight: "600",
                            borderRadius: "20px",
                            margin: "1.2rem",
                            marginLeft: 0,
                          }}
                        >
                          Log in
                        </Button>
                      </div>
                    )}
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
        {
          resetPwdModal ?
            <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={resetPwdModal} title={"Reset Password"}
              onCancel={() => {
                pwdForm.resetFields();
                localStorage.clear();
                setResetPwdModal(false);
              }}>
              <div
                className="AuditSection CreateAudit"
                style={{
                  padding: "10px",
                  maxHeight: "600px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                <div className="ThemeForm">
                  <Form
                    className="reset-pwd-form"
                    labelWrap={true}
                    name={"ReportForm"}
                    form={pwdForm}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    layout="horizontal"
                    colon={false}
                    onFinish={resetPwd}
                    size="large"
                  >
                    <Form.Item name="oldPassword" label={"Old Password"} rules={[
                      {
                        required: true,
                        message: "Please enter old password"
                      }
                    ]}>
                      <Input.Password type="password" style={{ minHeight: 40 }} />
                    </Form.Item>
                    <Form.Item name="newPassword" label={"New Password"} rules={[
                      {
                        required: true,
                        message: "Please enter new password"
                      },
                      {
                        min: 8,
                        message: "Password length should be minimum 8 characters"
                      },
                      {
                        pattern: "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
                        message: "Password should have atleast one special character, one uppercase letter, one lowercase letter and one numeric"
                      }
                    ]}>
                      <Input.Password type="password" style={{ minHeight: 40 }} />
                    </Form.Item>
                    <Form.Item
                      dependencies={['newPassword']}
                      name="confirmPassword" label={"Confirm Password"} rules={[
                        {
                          required: true,
                          message: "Please confirm password"
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('newPassword') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error('The new password that you entered do not match!'));
                          },
                        })
                      ]}>
                      <Input.Password type="password" style={{ minHeight: 40 }} />
                    </Form.Item>
                    <Row justify={"center"} style={{ marginTop: 20 }}>
                      <Col span={6}>
                        <Button htmlType="submit" type="primary">Submit</Button>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
              {/* <StAddNew
                initForm={pwdForm}
                password={true}
                urlMethod={"GET"}
                urlEndpoint={'/smodal'}
                formName="ResetPwd"
                //  setSmodalTitle={() => { }}
                urlData={{
                  dictName: 'reset_pwd'
                }}
                colSpan={24}
                onFormSubmit={resetPwd}
              /> */}
              {/* <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                <Button loading={pwdResetLoading} htmlType='submit' type="primary" form={'ResetPwd'}>Submit</Button>
              </div> */}
            </Modal> : <></>
        }


      </div>
    </>
  );
}

export default SignIn;
